var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35 0H1.65C0.739062 0 0 0.739062 0 1.65V15.95C0 16.8609 0.739062 17.6 1.65 17.6H9.35C10.2609 17.6 11 16.8609 11 15.95V1.65C11 0.739062 10.2609 0 9.35 0ZM5.5 16.5C4.89156 16.5 4.4 16.0084 4.4 15.4C4.4 14.7916 4.89156 14.3 5.5 14.3C6.10844 14.3 6.6 14.7916 6.6 15.4C6.6 16.0084 6.10844 16.5 5.5 16.5ZM9.35 12.7875C9.35 13.0144 9.16438 13.2 8.9375 13.2H2.0625C1.83563 13.2 1.65 13.0144 1.65 12.7875V2.0625C1.65 1.83562 1.83563 1.65 2.0625 1.65H8.9375C9.16438 1.65 9.35 1.83562 9.35 2.0625V12.7875Z",
    fill: "#0BD6A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.b8833366.svg";
export { ForwardRef as ReactComponent };